<script lang="ts" setup>
import type { StaticPageListResponse } from '~/types/StaticPageList';

definePageMeta({ breadcrumb: 'Блог' });

const route = useRoute();
const blogStore = useBlogStore();
const blogResponse = ref<StaticPageListResponse>();

const heading = 'Блог';
const title = computed(() => (route.query.page ? `${heading} - страница ${route.query.page}` : heading));

useHead({
  title: `${title.value} – Hellride.ru`,
  meta: [{ name: 'description', content: `${title.value} – интернет-магазина Hellride.ru` }],
});

await fetchData();

async function fetchData() {
  blogResponse.value = await blogStore.getBlog(route.query.page ? String(route.query.page) : null);

  if (import.meta.client) setTimeout(() => window.scrollTo(0, 0), 10);
}

watch(() => route.query, fetchData);
</script>

<template>
  <StaticPagesList
    :heading
    :items="blogResponse?.data ?? []"
    :pagination="blogResponse?.meta"
  />
</template>
